import { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'
import {t} from 'i18next'
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { Row, Col, Button, ModalBody, ModalHeader, ModalFooter } from 'reactstrap'
import axios from 'axios';

import env from '../../../env/src_config';
import { isNull } from '../../../izUtils';
import { linker, transformer } from '../../../helpers/fields';
import { axiosError, errorStatus } from '../../../helpers/response';
import { headersState, multiCheckLoading } from '../../../recoil/recoil';
import Spinner from '../../spinner/Spinner';

const ExportModal = ({ modaltoggle }) => {
    const navigate = useNavigate();

    const setMultiCheckLoading = useSetRecoilState(multiCheckLoading);
    const headers = useRecoilValue(headersState);
    const [inputs, setInputs] = useState(null);
    const [showErrors, setShowErrors] = useState(false);

    const lsFilterName = 'AKODA.archiveFilter';

    useEffect(() => {
        updateData(false, null);

    }, []) // eslint-disable-line

    const updateData = (save, passedInputs) => {
        let payload = { save };

        if (!isNull(passedInputs)) {
            payload.data = {};
            const keys = Object.keys(passedInputs);

            for (let i = 0; i < keys.length; i++) {
                if (!isNull(passedInputs[keys[i]].value) && passedInputs[keys[i]].value.length !== 0) {
                    payload.data[keys[i]] = passedInputs[keys[i]].value;
                } else {
                    payload.data[keys[i]] = "";
                }
            }
        }

        let sendHeaders = { headers: {...headers} };
        if (save) {
            sendHeaders.responseType = 'blob';
        }

        let lsFilters = JSON.parse(localStorage.getItem(lsFilterName));

        if (!isNull(lsFilters)) {
            payload.filters = {};
            const keys = Object.keys(lsFilters);

            for (let i = 0; i < keys.length; i++) {
                if (!isNull(lsFilters[keys[i]].value) && lsFilters[keys[i]].value.length !== 0) {
                    payload.filters[keys[i]] = lsFilters[keys[i]].value;
                } else {
                    payload.filters[keys[i]] = "";
                }
            }

            delete payload.filters.pagination_page;
            delete payload.filters.pagination_show_per_page;
            delete payload.filters.pagination_total;
        }

        axios.post(env.api + '/api/task/archive/export', payload, sendHeaders).then(response => {
            if (save) {
                if (response.data.type.includes('spreadsheetml.sheet')) {
                    const href = window.URL.createObjectURL(response.data);
                    const a = document.createElement('a');
                    const contentDisposition = response.headers['content-disposition'];
                    let filename = 'archive_export.xlsx';
                    if (contentDisposition) {
                        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                        if (filenameMatch && filenameMatch[1]) {
                            filename = filenameMatch[1].replace(/['"]/g, '');
                        }
                    }
                    a.setAttribute('download', filename);
                    a.href = href;
                    a.click();
                    window.URL.revokeObjectURL(href); // Clean up the object URL

                    modaltoggle();
                } else {
                    errorStatus(response.data, t);
                    setShowErrors(true);
                }
            }

            setMultiCheckLoading(false) // Set loading for field MultiCheck to false
            if (!isNull(response.data.data)) {
                let transformedResponse = transformer(response.data.data);
                setInputs(transformedResponse);
            }
        }).catch(error => {
            axiosError(error, navigate);
        });
    }

    const multiChange = (value, name, component) => {
        setMultiCheckLoading(name + '-' + component?.id)
        let clonedInputs = { ...inputs };

        if (clonedInputs[name].value.length === 0) {
            clonedInputs[name].value.push(value)
        } else {
            if (clonedInputs[name].value.indexOf(value) === -1) {
                clonedInputs[name].value.push(value);
            } else {
                const filteredValues = clonedInputs[name].value.filter(el => el !== value);
                clonedInputs[name].value = filteredValues;
            }
        }

        updateData(false, clonedInputs);
    }

    const mapLinker = (field) => {
        const inputlinkerFields = {
            field,
            inputs,
            showErrors,
            component: {id: 'export_archive'},
            multiHandler: (value, id, component) => multiChange(value, id, component),
        }

        return linker(inputlinkerFields);
    }

    return (
        <Fragment>
            <ModalHeader toggle={modaltoggle}>{t('filter.export.title')}</ModalHeader>
            <ModalBody>
                {isNull(inputs)
                    ? <Spinner />
                    : <div className="theme-form">
                        <Row>
                            <Col sm="12">
                                { ['export_fields'].map(field => mapLinker(field)) }
                            </Col>
                        </Row>
                    </div>
                }
            </ModalBody>
            <ModalFooter>
                <div className='w-100 d-flex justify-content-between'>
                    <Button color="danger" className='me-2' onClick={modaltoggle}>{t('close')}</Button>
                    <Button color="primary" className='me-2' onClick={() => updateData(true, inputs)}>{t('export')}</Button>
                </div>
            </ModalFooter>
        </Fragment>
    )
}

export default ExportModal